import React from 'react';

const variants = {
  primary: 'badge-primary',
  success: 'badge-success',
  warning: 'badge-warning',
  danger: 'badge-danger',
  info: 'badge-info',
};

const Badge = ({ children, variant = 'primary', dot = false, className = '' }) => {
  return (
    <span className={`badge ${variants[variant]} ${className}`}>
      {dot && <span className={`w-2 h-2 rounded-full mr-2 ${
        variant === 'success' ? 'bg-emerald-500' :
        variant === 'warning' ? 'bg-amber-500' :
        variant === 'danger' ? 'bg-red-500' :
        variant === 'info' ? 'bg-cyan-500' : 'bg-indigo-500'
      }`} />}
      {children}
    </span>
  );
};

export default Badge;
